import { createStore } from 'vuex';
import player from './modules/player';
import shop from './modules/shop';
import fishing from './modules/fishing';
import inventory from './modules/inventory';
import maps from './modules/maps';
import dailyMissions from './modules/dailyMissions';
import competition from './modules/competition';
import events from './modules/events';
import business from './modules/business';
import employees from './modules/employees';
import clan from './modules/clan'; // Add clan module import
import auth from './modules/auth';
import SoundController from './modules/SoundController';
import rewards from './modules/rewards';
import items from './modules/items';
import announcements from './modules/announcements';
import upgrade from './modules/upgrade';
import skills from './modules/skills';
import fishMarket from './modules/fishMarket';
import language from './modules/language'; // Import language module
import market from './modules/market';
import avisos from './modules/avisos';
import exploration from './modules/exploration';
// O mercado ENTRE JOGADORES. Nome comprido de proposito: 'market', acima, e o
// mercado do DIA, que e sabor e nao vende nada. Ver o cabecalho do modulo.
import mercadoDeJogadores from './modules/mercadoDeJogadores';
import pescador from './modules/pescador';

const store = createStore({
  modules: {
    player,
    shop,
    fishing,
    inventory,
    maps,
    dailyMissions,
    competition,
    events,
    business,
    employees,
    clan, // Add clan module to the modules
    auth,
    SoundController,
    rewards,
    items,
    announcements,
    upgrade,
    skills,
    fishMarket,
    language,
    market,
    avisos,
    exploration,
    mercadoDeJogadores,
    pescador
  },
  actions: {
    async initializeStore() {  // Removed unused parameters
      try {
        // Add your async store initialization logic here
        // When needed, add parameters back: ({ commit, dispatch })
      } catch (error) {
        console.error('Store initialization failed:', error);
        throw error;
      }
    }
  }
});

export default store;